export default 'event:assistent-chat-favorited';

export type ChatFavoritedEventParameters = {
    chatId: string,
};
